import { ContactUs, CopyrightFooter, DataGrid, FindAFoundation, MaterialInput } from 'app/components'
import { Container, IAppState } from 'app/containers/Container'
import * as React from 'react'
import { Button, Col, Panel, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom';

class AreYouFoundation extends Container<{}, {}> {

  mapAppStateToContainerState(appState: IAppState): {} {
    return {}
  }

  render() {
    return (
      <section>
        <section className="margin-y-lg">
          <div className="well well-info">
            <div className="container animated fadeIn">
              <header className="margin-bottom">
                <h2 className="hidden-xs">
                  Are you a Foundation?&nbsp;
                  <small>Request Performance Reports</small>
                </h2>
                <h3 className="visible-xs">Are you a Foundation?</h3>
              </header>

              <article className="margin-bottom">
                <FindAFoundation />
              </article>
            </div>
          </div>
        </section>

        <footer>
          <ContactUs />
          <CopyrightFooter />
        </footer>
      </section>
    )
  }
}

export {
  AreYouFoundation
}



// WEBPACK FOOTER //
// ./src/app/containers/AreYouAFoundation/index.tsx